import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var footerHeight = '72px';
export var footer = /*#__PURE__*/css("position:relative;height:", footerHeight, ";display:flex;justify-content:space-between;align-items:center;background:", tokens.colors.neutral.surface.default, ";");